// =============================================================================
// src/chrome/topbar/topbar-identity.ts — Identidade do OPERADOR (sessão) + chip do
//   gabinete acompanhado.
//
// Proveniencia: reforma institucional 2026-06 (Fase 4). O avatar "TS" era
//   hardcoded em 2 markups (topbar + account menu) e o chrome principal nao
//   dizia DE QUEM e a operacao. 2026-06-23: o GABINETE deixou de ser a persona
//   fictícia hardcoded ("Gab. Ver. Helena Braga") e passou a vir do resolver
//   dinâmico (src/app/owner-identity) — segue o tenant (Omar Aziz no piloto).
//   O OPERADOR (Thiago Sotero) segue mock até haver sessão real.
// =============================================================================

import { initialsOf, resolveOwnerIdentity } from '../../app/owner-identity';

/** Operador logado (mundo-mock; vira sessao real quando houver backend). */
export const TOPBAR_OPERATOR = {
  name: 'Thiago Sotero',
  role: 'Estratégia · Manaus',
} as const;

/**
 * Iniciais (primeiro + ultimo) para o avatar; default = operador logado.
 * Delega a initialsOf (src/app/owner-identity) — cálculo em fonte única (DRY).
 *
 * @example operatorInitials() // 'TS'
 * @example operatorInitials('Omar Aziz') // 'OA'
 */
export function operatorInitials(fullName: string = TOPBAR_OPERATOR.name): string {
  return initialsOf(fullName);
}

/**
 * Chip do gabinete acompanhado na topbar. Lê a identidade do dono via
 * resolveOwnerIdentity() — dinâmica do backend (tenant) com fallback ao piloto Omar.
 *
 * @example buildGabineteChipMarkup() // <span class="u-topbar-gabinete">…Sen. Omar Aziz…</span>
 */
export function buildGabineteChipMarkup(): string {
  const owner = resolveOwnerIdentity();
  return `<span class="u-topbar-gabinete" title="${owner.name} · ${owner.meta}">
      <i class="ti ti-building-bank" aria-hidden="true"></i><span>${owner.name}</span>
    </span>`;
}
